<template>
  <div style="width: 98%; margin: 0 auto">
    <el-card shadow="always" class="showBox">
      <div style="border: 1px solid #ccc">
        <el-row :gutter="24" style="background: #f1f1f1; margin: 0px; padding: 10px 0">
          <el-col :span="16">
            <div class="cente">
              <el-col :span="3">
                <el-image :src="room.avatar" :preview-src-list="room.pictures" style="width: 50px; height: 50px" />
              </el-col>
              <el-col :span="21">
                <el-col :span="12">
                  <span class="cente_span">
                    {{ room.name }}({{ room.room_admin_name }}-{{
                      room.telephone
                    }})
                  </span>
                  <p class="fontsize14">可容纳人数：{{ room.capacity }}人</p>
                </el-col>
                <el-col :span="7">
                  <div class="fontsize14">
                    会议地点：{{ room.address.address }} - {{ room.area }}
                  </div>
                </el-col>
                <el-col :span="11">
                  <div style="margin-top: 10px; display: inline-block">
                    <el-tag v-for="(item, index) in room.equipments" :key="index" style="margin-left: 5px">
                      {{ item.equipment_name }}
                    </el-tag>
                  </div>
                </el-col>
              </el-col>
            </div>
          </el-col>
          <el-col :span="8" style="overflow: auto">
            <div style="margin-top: 10px; float: right; margin-right: 30px">
              <el-button type="primary" size="small" :loading="loading" @click="sub('form')">发起会议</el-button>
            </div>
          </el-col>
        </el-row>
        <el-divider>
          <i class="el-icon-collection-tag" />
        </el-divider>
        <el-form ref="form" :model="form" :rules="rules" label-width="120px" style="padding: 0 10px">
          <el-row :gutter="24">
            <div style="margin-left: 10px;">
              <meeting-time :roomid="$route.query.id" :isList="false" @reload="meetingTimeReload" />
            </div>
            <el-divider>
              <i class="el-icon-collection-tag" />
            </el-divider>
            <el-col :span="12">
              <el-form-item label="选择时间为:">
                <span v-if="estimate_start_time != ''" style="font-size: 18px">
                  {{ estimate_start_time }}~
                  {{ estimate_end_time }}
                </span>
              </el-form-item>
              <el-form-item label="会议类型" prop="type_id" class="fdg">
                <el-select v-model="form.type_id" placeholder="请选择会议类型" @change="checkType()">
                  <el-option v-for="(item, index) in meetingoptions" :key="index" :label="item.type_name"
                    :value="item.id" :disabled="item.id == 7" />
                </el-select>
              </el-form-item>
              <el-form-item v-if="needDepart" label="所属部门" prop="secretary_department_id" class="fdg">
                <el-select v-model="form.secretary_department_id" placeholder="请选择部门">
                  <el-option v-for="(item, index) in departmentList" :key="index" :label="item.department"
                    :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item label="保密类型" prop="secrecy_type">
                <el-radio-group v-model="form.secrecy_type">
                  <el-radio :label="0">普通会议（非保密）</el-radio>
                  <el-radio :label="1">一级会议（保密）</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="是否需要评分" prop="is_need_score">
                <el-radio-group v-model="form.is_need_score">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="召集人" class="fdg" prop="convenor_user_id">
                <el-select v-model="form.convenor_user_id" :remote-method="remoteMethod" :loading="loading" filterable
                  remote clearable reserve-keyword placeholder="请输入姓名" value-key="username"
                  @change="((val) => { selectPersont(val, 'convenor') })">
                  <el-option v-for="item in personInChargeList" :key="item.username"
                    :label="item.name + '(' + item.username + ')'" :value="item" />
                </el-select>
              </el-form-item>
              <el-form-item label="主持人" class="fdg" prop="host_user_id">
                <el-select v-model="form.host_user_id" :remote-method="remoteMethod" :loading="loading" filterable
                  remote clearable reserve-keyword placeholder="请输入姓名" value-key="username"
                  @change="((val) => { selectPersont(val, 'host') })">
                  <el-option v-for="item in personInChargeList" :key="item.username"
                    :label="item.name + '(' + item.username + ')'" :value="item" />
                </el-select>
              </el-form-item>
              <el-form-item label="会议秘书" class="fdg" prop="secretary_user_id">
                <el-select v-model="form.secretary_user_id" :remote-method="remoteMethod" :loading="loading" filterable
                  remote clearable reserve-keyword placeholder="请输入姓名" value-key="username"
                  @change="((val) => { selectPersont(val, 'secretary') })">
                  <el-option v-for="item in personInChargeList" :key="item.username"
                    :label="item.name + '(' + item.username + ')'" :value="item"
                    :disabled="item.userId == form.convenor_user_id.userId" />
                </el-select>
              </el-form-item>
              <el-form-item label="参会人员">
                <div
                  style="display:inline-block;min-height: 40px;margin-right: 14px; width: 430px; border: 1px solid #dcdfe6; border-radius: 4px; cursor: pointer; line-height: 40px;"
                  @click="selectUser">
                  <span v-if="userList.length === 0" style="margin-left: 15px; color: #b2b2b2">请选择人员</span>
                  <el-tag v-for="(item, index) in userList" :key="item.userId" closable @close="removeUser(index)"
                    style="margin-left: 5px; height: 22px; line-height: 22px">
                    {{ item.name }}({{ item.username }})
                  </el-tag>
                </div>
                <el-button type="primary" size="small" @click="componentOpen">查询参会人会议时间</el-button>
              </el-form-item>
              <el-form-item label="提醒时间" class="fdg" prop="reminder_time">
                <el-select v-model="form.reminder_time" placeholder="请选择提醒时间">
                  <el-option label="无提醒" value="0" />
                  <el-option label="开会前5分钟提醒" value="5" />
                  <el-option label="开会前15分钟提醒" value="15" />
                  <el-option label="开会前30分钟提醒" value="30" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="会议主题" prop="subject">
                <el-input v-model="form.subject" placeholder="请输入内容" />
              </el-form-item>
              <el-form-item label="会议描述">
                <el-input :autosize="{ minRows: 2 }" v-model="form.describe" type="textarea" placeholder="请输入内容" />
              </el-form-item>
              <el-form-item v-for="(domain, index) in form.lssue" :label="'会议议题'" :key="domain.index" prop="lssue">
                <el-input v-model="domain.value">
                  <template v-if="index !== 0" slot="append">
                    <i class="el-dialog__close el-icon el-icon-close" @click.prevent="removeDomain(domain)" />
                  </template>
                </el-input>
              </el-form-item>
              <p style="text-align: center">
                <el-button type="success" icon="el-icon-circle-plus-outline" circle @click="addDomain" />
              </p>
              <div style="margin-top: 10px">
                <el-button type="primary" size="small" :loading="loading" @click="sub('form')">发起会议</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <!-- 人员选择 -->
    <user-conf v-bind.sync="selectObj" @save="saveUsre"></user-conf>
    <component :is="componentId" :info="info" :visible="componentVisible" @closeVisible="componentClose"></component>
  </div>
</template>

<script>
// import {
//   mapGetters
// } from 'vuex'
import { getDDusers, getDepartTree, gitusers } from '@/api/user'
import {
  meeting,
  meetingtype,
  meetingroomID
  // meetingsearch 无效的请求
} from '@/api/conferencebooking'
import meetingTime from '@/components/meetingTime'
import { getUserInfoById } from '@/api/login'
import { getAllSecretary } from '@/api/secretary'
import userConf from '@/components/selectPerson'
import idleTab from './components/idleTab.vue'
import _ from 'lodash'

export default {
  components: {
    meetingTime,
    userConf,
    idleTab
  },
  data() {
    return {
      componentId: null,
      componentVisible: false,
      info: {},
      meetingoptions: [],
      room: {
        address: {}
      },
      formInline: {},
      username: [],
      estimate_start_time: '',
      estimate_end_time: '',
      usernames: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      list: [],
      loading: false,
      users: [],
      personInChargeList: [],
      data: '',
      form: {
        is_need_score: 1,
        lssue: [
          {
            value: ''
          }
        ],
        subject: '',
        secrecy_type: 0,
        describe: '',
        radio: '1',
        type: '',
        urgency: '',
        contact_user_id: '',
        convenor_user_id: '',
        host_user_id: '',
        secretary_user_id: '',
        attendees: [],
        reminder_time: '5',
        // department: '',
        secretary_department_id: '',
        isdata: []
      },
      nubm: 0,
      rules: {
        type_id: [
          {
            required: true,
            message: '请选择会议类型',
            trigger: 'change'
          }
        ],
        secrecy_type: [
          {
            required: true,
            message: '请选择保密类型',
            trigger: 'change'
          }
        ],
        urgency: [
          {
            required: true,
            message: '请选择紧急程度',
            trigger: 'change'
          }
        ],
        contact_user_id: [
          {
            required: true,
            message: '请选择联系人',
            trigger: 'change'
          }
        ],
        convenor_user_id: [
          {
            required: true,
            message: '请选择召集人',
            trigger: 'change'
          }
        ],
        host_user_id: [
          {
            required: true,
            message: '请选择主持人',
            trigger: 'change'
          }
        ],
        secretary_user_id: [
          {
            required: true,
            message: '请选择会议秘书',
            trigger: 'change'
          }
        ],
        reminder_time: [
          {
            required: true,
            message: '请选择提醒时间',
            trigger: 'change'
          }
        ],
        subject: [
          {
            required: true,
            message: '请输入会议主题',
            trigger: 'blur'
          }
        ],
        lssue: [
          {
            required: true,
            message: '请输入会议议题',
            trigger: 'change'
          }
        ],
        describe: [
          {
            required: true,
            message: '请输入会议描述',
            trigger: 'blur'
          }
        ],
        secretary_department_id: [
          {
            required: true,
            message: '请选择所属部门',
            trigger: 'change'
          }
        ],
        is_need_score: [{
          required: true,
          message: '请选择是否需要评分',
          trigger: 'change'
        }]
      },
      departmentList: [], // 所有部门列表
      needDepart: false,
      selectObj: {
        visible: false,
        allUser: [],
        departTree: []
      },
      allUser: [], // 全部员工
      userList: [],
      departTree: []
    }
  },
  created() {
    this.getPerson(0)
    this.getDepart()
  },
  mounted() {
    const user = {
      name: this.$store.getters.name,
      username: this.$store.getters.username,
      userId: this.$store.getters.userId
    }
    this.username.push(user)
    console.log('id', this.$route.query.id)
    this.form.room_id = this.$route.query.id

    meetingroomID(this.$route.query.id).then((response) => {
      console.log(response)
      this.room = response.data.room
    }).catch((err) => {
      console.log(err)
    })

    meetingtype().then((response) => {
      console.log(response)
      this.meetingoptions = response.data.types
    }).catch((err) => {
      console.log(err)
    })
    this.getDepartment()
    this.getuserlist({ departmentId: 0 }, 0)
  },
  methods: {
    componentOpen() {
      if (!this.userList.length) {
        this.$message.warning('请先选择参会人员')
        return
      }
      console.log('this.userList', this.userList)
      this.info.userList = _.cloneDeep(this.userList)
      this.componentId = 'idleTab'
      this.componentVisible = true
    },
    componentClose(tag) {
      // if (tag) {
      //   this.getList()
      // }
      this.componentVisible = false
      this.componentId = null
      this.info = {}
    },
    getuserlist(data, type) {
      gitusers(data).then((response) => {
        if (type === 0) {
          this.users = response.data
          this.list = this.users.map((item) => {
            return {
              username: item.username,
              name: item.name,
              userId: item.userId
            }
          })
        } else {
          this.usertableList = response.data
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    checkType() {
      this.needDepart = false
      this.form.secretary_department_id = ''
      this.meetingoptions.forEach((item) => {
        if (item.id === this.form.type_id && item.is_department === 1) {
          this.needDepart = true
        }
      })
    },
    getDepartment() {
      const params = {
        is_available: 1,
        page: 1,
        page_size: 10000
      }
      getAllSecretary(params).then((res) => {
        console.log(res)
        if (res.code === 'success' && res.data && res.data.secretary) {
          this.departmentList = res.data.secretary
        } else {
          this.departmentList = []
        }
      })
    },
    selectPersont(val, type) {
      if (type === 'convenor') {
        if (!val) {
          this.personInChargeList = []
        } else {
          getUserInfoById(val.userId).then((res) => {
            if (res && res.data) {
              this.form.department_id = res.data.departmentId // 召集人的部门
            }
          }).catch()
          // 处理首次选择召集人，默认为主持人
          this.form.host_user_id = this.nubm === 0 ? val.name + '(' + val.username + ')' : ''
          this.nubm++
        }
      }
      if (['convenor', 'host', 'secretary'].includes(type) && val) {
        if (this.username.map(item => item.userId).indexOf(val.userId) === -1) {
          this.username.push(val)
        }
      }
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.personInChargeList = this.list.filter((item) => {
            return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      }
    },
    sub(formName) {
      const THis = this
      console.log(THis.form.estimate_start_time)
      if (!THis.form.estimate_start_time) {
        this.$message({
          message: '请选择时间',
          type: 'warning'
        })
        return
      }
      if (this.userList.length > 0) {
        //   参会人员
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // 召集人和会议秘书不能是同一个
            if (THis.form.convenor_user_id.userId === THis.form.secretary_user_id.userId) {
              this.$message.warning('召集人和会议秘书不可以是同一个人')
              return
            }
            const type_id = THis.form.type_id
            const convenor = {
              name: THis.form.convenor_user_id.name,
              user_id: THis.form.convenor_user_id.userId,
              workcode: THis.form.convenor_user_id.username
            }
            let host = ''
            let secretary = ''
            if (typeof THis.form.host_user_id === 'object') {
              host = {
                name: THis.form.host_user_id.name,
                user_id: THis.form.host_user_id.userId,
                workcode: THis.form.host_user_id.username
              }
            } else {
              host = convenor
            }
            if (typeof THis.form.secretary_user_id === 'object') {
              secretary = {
                name: THis.form.secretary_user_id.name,
                user_id: THis.form.secretary_user_id.userId,
                workcode: THis.form.secretary_user_id.username
              }
            } else {
              secretary = convenor
            }
            const attendees = THis.userList.map(item => {
              return {
                name: item.name,
                user_id: item.userId,
                workcode: item.username
              }
            })
            const lssue = THis.form.lssue.filter(item => item.value).map(item => item.value)
            if (type_id !== 7 && lssue.length === 0) {
              this.$message.error('请输入会议议题！')
              return
            }
            const data = {
              subject: THis.form.subject,
              lssue: lssue,
              type_id: type_id,
              secrecy_type: THis.form.secrecy_type,
              room_id: THis.form.room_id,
              describe: THis.form.describe,
              reminder_time: THis.form.reminder_time,
              estimate_start_time: THis.form.estimate_start_time,
              estimate_end_time: THis.form.estimate_end_time,
              convenor: convenor,
              host: host,
              secretary: secretary,
              attendees: attendees,
              department_id: this.form.department_id,
              is_need_score: this.form.is_need_score
            }
            if (this.needDepart) {
              data.secretary_department_id = this.form.secretary_department_id
            } else {
              data.secretary_department_id = 0
            }
            this.loading = true
            meeting(data).then((response) => {
              this.loading = false
              if (response.code !== 'success') return
              this.$alert('会议预约成功', '提示', {
                confirmButtonText: '查看会议详情',
                callback: (action) => {
                  if (this.form.type_id === 7) {
                    // 如果是早会就跳转早会详情
                    this.$router.push({
                      name: 'morningDetails',
                      query: {
                        id: response.data.meeting.id
                      }
                    })
                  } else {
                    this.$router.push({
                      name: 'seeDetails',
                      query: {
                        id: response.data.meeting.id
                      }
                    })
                  }
                }
              })
            }).catch((error) => {
              this.loading = false
              let text = ''
              if (error.errors.attendees) {
                for (const key in error.errors.attendees) {
                  const element = error.errors.attendees[key]
                  text +=
                    '<div>参会人：' +
                    element.name +
                    '【' +
                    element.workcode +
                    '】 ( 编号：' +
                    element.meeting_id +
                    ' )' +
                    '</div>'
                }
                // 以下参会人员会议冲突（名称【工号】（编号：44,333）
                this.$notify.error({
                  title: '以下参会人员会议冲突',
                  message: text,
                  dangerouslyUseHTMLString: true,
                  duration: 0,
                  customClass: 'alertClass'
                })
              }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      } else {
        this.$message({
          message: '请选择参会人员',
          type: 'warning'
        })
      }
    },
    addDomain() {
      this.form.lssue.push({
        value: ''
      })
    },
    meetingTimeReload(time) {
      console.log(1111, time)
      this.estimate_start_time = time.startTime
      this.estimate_end_time = time.endTime
      this.form.estimate_start_time = time.startTime
      this.form.estimate_end_time = time.endTime
    },
    removeDomain(item) {
      var index = this.form.lssue.indexOf(item)
      if (index !== -1) {
        this.form.lssue.splice(index, 1)
      }
    },
    selectUser() {
      if (this.userList.length <= 0) {
        // 当选择参会人员比如10个人 选中了后再打开弹出选择人员，不能又赋值为 召集人 秘书 主持人 秘书自己这四个人
        this.userList = [...this.username]
      }
      this.selectObj = {
        visible: true,
        allUser: this.allUser,
        departTree: this.departTree,
        hasChoosed: this.userList // 已选择的
      }
    },
    saveUsre(params) {
      this.selectObj.visible = false
      this.userList = JSON.parse(JSON.stringify(params))
    },
    // 获取部门数据
    getDepart() {
      this.departTree = []
      getDepartTree().then((res) => {
        if (res.code === '000000') {
          this.departTree = res.data
        }
      }).catch()
    },
    removeUser(index) {
      this.userList.splice(index, 1)
    },
    // 获取员工 0为全部数据
    getPerson(id) {
      this.allUser = []
      getDDusers(id).then((res) => {
        if (res.code === '000000') {
          this.allUser = res.data
        }
      }).catch()
    }
  }
}
</script>
<style>
.showBox .el-divider--horizontal {
  margin-bottom: 10px;
  margin-top: 0px;
}

.el-table--border:after,
.el-table--group:after,
.el-table:before {
  position: static;
  /* 表格下面一条线，原是 relatve定位，删除就可以 */
}
</style>
<style scope>
.cente .cente_span {
  line-height: 1.7;
  display: block;
}

.fontsize14 {
  font-size: 14px;
}

.fdg {
  width: 48%;
  display: inline-block;
}

.bg {
  background: rebeccapurple !important;
}

ul {
  padding: 0;
  margin: 0;
}

.demo-form-inline {
  margin-top: 10px;
}

.alertClass {
  width: 500px;
}
</style>
